import { render, staticRenderFns } from "./DiagnosisHelp.vue?vue&type=template&id=452018e4&"
import script from "./DiagnosisHelp.vue?vue&type=script&lang=ts&"
export * from "./DiagnosisHelp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('452018e4')) {
      api.createRecord('452018e4', component.options)
    } else {
      api.reload('452018e4', component.options)
    }
    module.hot.accept("./DiagnosisHelp.vue?vue&type=template&id=452018e4&", function () {
      api.rerender('452018e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/inputs/diagnosis/DiagnosisHelp.vue"
export default component.exports